<dgx-modal
  [canCancel]="true"
  [canCloseHeader]="false"
  [closeOnSubmit]="true"
  [useDefaultForm]="false"
  [isSubmitDisabled]="false"
  [submitButtonType]="'primary'"
  [isHeaderBorderless]="true"
  [useDefaultSubmitButton]="false"
  [item]="tag"
  (dismiss)="onContinue($event)"
>
  <!-- Modal Header -->
  <ng-container class="modal-header">
    <!-- creating our own close here as we want a different action on x than "continue"(cancel) -->
    <button
      [attr.aria-label]="'Core_Close' | translate"
      (click)="closeModal()"
      class="l_flex--align-right modal-header__close-icon js-modal-close-btn l_flex-none"
      type="button"
      data-dgat="modalHeader-e5f"
    >
      <df-icon icon="cross"></df-icon>
    </button>
  </ng-container>
  <!-- Modal Body -->
  <ng-container class="modal-body">
    <!-- Modal Body Image-->
    <div class="center-text">
      <img
        class="not-too-wide skillton-image"
        [src]="getBlobUrl('/content/img/onboarding/skillton-box.png')"
        [srcset]="getBlobUrl('/content/img/onboarding/skillton-box-2x.png')"
        [alt]="'Core_AreYouSure' | translate"
      />
    </div>

    <!-- Modal Body -->
    <h3
      [innerHTML]="'Onboarding_AreYouSureHeading' | translate"
      class="center-text guts-p-h-2 guts-p-v-1 h3"
    ></h3>

    <div
      [innerHTML]="'Onboarding_AreYouSureDescription' | translate"
      class="center-text guts-p-h-2 guts-m-b-2 par par--small par--light"
    ></div>
  </ng-container>

  <ng-container class="modal-footer">
    <button
      dfButtonType="primary"
      (click)="submit()"
      df-button
      type="submit"
      data-dgat="are-you-sure-rating-modal-e66"
    >
      {{ 'Core_Submit' | translate }}
    </button>
  </ng-container>
</dgx-modal>
